import React from 'react';
import {BsLinkedin} from 'react-icons/bs';
import {FaGithub} from 'react-icons/fa';
import {FiInstagram} from "react-icons/fi";

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
      <a href="https://www.linkedin.com/in/abhi-patel-9a4535242/" target='_blank'><BsLinkedin/></a>
      <a href="https://github.com/Abhipatel18" target='_blank'><FaGithub/></a>
      <a href="https://www.instagram.com/_a_b_h_i_0_2/" target='_blank'><FiInstagram/></a>
    </div>
  )
}

export default HeaderSocials
